import { createAction } from "redux-actions";

export const ORDER_LIST = "ORDER_LIST";
export const orderList = createAction(ORDER_LIST);

export const DETAIL_ORDER = "DETAIL_ORDER";
export const detailOrder = createAction(DETAIL_ORDER);

export const UPDATE_ORDER = "UPDATE_ORDER";
export const updateOrder = createAction(UPDATE_ORDER);

export const DELETE_ORDER = "DELETE_ORDER";
export const deleteOrder = createAction(DELETE_ORDER);

export const SYNC_ORDER = "SYNC_ORDER";
export const syncOrder = createAction(SYNC_ORDER);

export const ORDEREMAILLIST = "ORDEREMAILLIST";
export const orderEmailList = createAction(ORDEREMAILLIST);

export const ORDEREMAIDELETE = "ORDEREMAIDELETE";
export const orderEmailDelete = createAction(ORDEREMAIDELETE);

export const ORDEREMAILCREATE = "ORDEREMAILCREATE";
export const orderEmailCreate = createAction(ORDEREMAILCREATE);

export const ORDEREMAILDETAIL = "ORDEREMAILDETAIL";
export const orderEmailDetail = createAction(ORDEREMAILDETAIL);

export const CAPTURESNAPFINANCE = "CAPTURESNAPFINANCE";
export const captureSnapFinance = createAction(CAPTURESNAPFINANCE);
